import { IAgentFlags } from "store/entities/agents";

export enum Features {
  Archive = "Archive",
}

export const FEATURES_KEYS = {
  [Features.Archive]: "archiveVisitedDate",
} satisfies Partial<Record<Features, keyof IAgentFlags>>;

export const FEATURES_NEW_FEATURE_CAMPAIGNS: { [key in Features]?: [string, string, string][] } = {
  [Features.Archive]: [["2023-01-01T14:00:00.000Z", "2023-04-04T14:00:00.000Z", ""]],
};
